import React from "react";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { toast } from "react-toastify";

const LogoutButton = () => {
  const [user] = useAuthState(auth);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      toast.success("You’ve been logged out.");
      navigate("/login");
    } catch (err) {
      toast.error("Logout failed. Try again.");
    }
  };

  // 👇 Don’t show the button if no user is logged in
  if (!user) return null;

  return (
    <button
      onClick={handleLogout}
      className="bg-red-600 text-white px-4 py-2 rounded-full hover:bg-red-700 transition"
    >
      Logout
    </button>
  );
};

export default LogoutButton;
